import { FC, Suspense } from 'react';
import ReportHubList from './ReportHubList';
import { ReportType } from '../../models/Report';
import { ThreeDotLoader } from '../Fallback/ThreeDotsLoader';
import { useGetDropdownsOptionForReports } from '../../custom-hooks/useGetDropdownsOptionForReports';

const ReportHubContainer: FC = () => {
  const { allDropdowns, setAllDropdowns, allClassesData } = useGetDropdownsOptionForReports();

  return (
    <div className="w-full nc_block">
      <div className="flex flex-column">
        <Suspense fallback={<ThreeDotLoader />}>
          <div className="p-3">
            <ReportHubList
              reportType={ReportType.DIAGNOSTIC}
              allDropdowns={allDropdowns}
              setAllDropdowns={setAllDropdowns}
              allClassesData={allClassesData}
            />
          </div>
          <div className="p-3">
            <ReportHubList
              reportType={ReportType.PROGRESS}
              allDropdowns={allDropdowns}
              setAllDropdowns={setAllDropdowns}
              allClassesData={allClassesData}
            />
          </div>
        </Suspense>
      </div>
    </div>
  );
};

export default ReportHubContainer;
